import { createRouter, createWebHistory } from 'vue-router'
import AuthService from '@/services/auth.service'
import Logged from '@/views/Logged.vue'
import Signin from '@/views/Signin.vue'
import SignUp from '@/views/SignUp.vue'
import PasswordDefinition from '@/views/PasswordDefinition.vue'
import MyArea from '@/views/MyArea.vue'
import ActiveAccount from '@/views/ActiveAccount.vue'
import routeConfig from '@/locale/internationalization.json';

const components = {
    'TermsOfUse': () => import('@/views/privacy/TermsOfUse.vue'),
    'PrivacyPolicy': () => import('@/views/privacy/PrivacyPolicy.vue'),
    'PersonalData': () => import('@/views/privacy/PersonalData.vue'),
    'PrivacyCookies': () => import('@/views/privacy/PrivacyCookies.vue'),
    'Lgpd': () => import('@/views/privacy/Lgpd.vue'),
    'Legal': () => import('@/views/privacy/Legal.vue'),
    'Accessibility': () => import('@/views/privacy/Accessibility.vue'),

};

let dynamicRoutes = [];

// Função para criar rotas dinamicamente
function createRoutes(config) {
    if (config.footer) {
        for (const key in config.footer) {
            if (config.footer[key].url && config.footer[key].component) {
                const component = components[config.footer[key].component];
                if (component) {
                    for (const lang in config.footer[key].url) {
                        if (config.footer[key].url[lang]) {
                            dynamicRoutes.push({
                                path: config.footer[key].url[lang],
                                name: `${key}-${lang}`,
                                component: component
                            });
                        }
                    }
                } else {
                    console.error(`Componente não encontrado: ${config.footer[key].component}`);
                }
            }
        }
    }
}

createRoutes(routeConfig);

const publicFooterPaths = dynamicRoutes
    .map(route => route.path)
    .filter(path => path.startsWith('/'));

const discourseRoutes = __DISCOURSE_ENABLED__
    ? [
        {
            path: '/forum',
            name: 'forum',
            component: () => import('@/views/discourse/Home.vue')
        },
        {
            path: '/forum/categoria/:name/:id',
            name: 'forum-category',
            component: () => import('@/views/discourse/Home.vue'),
            props: true
        },
        {
            path: '/forum/subcategoria/:name/:id',
            name: 'forum-subcategory',
            component: () => import('@/views/discourse/Home.vue'),
            props: true
        },
        {
            path: '/forum/:category/post/:name/:id',
            name: 'forum-post',
            component: () => import('@/views/discourse/Post.vue'),
            props: true
        },
    ]
    : [];

const launchRoutes = __LAUNCHES_ENABLED__
    ? [
        {
            path: import.meta.env.VITE_BASE_PATH_LAUNCHES,
            name: 'lancamentos',
            component: () => import('@/views/Lancamento.vue')
        },
    ]
    : [];

const router = createRouter({
    history: createWebHistory(import.meta.env.VITE_BASE_PATH || '/'),
    linkActiveClass: 'active',
    mode: 'history',
    scrollBehavior(to, from, savedPosition) {
        //if (to.hash) return { el: to.hash, top: 0 }
        return { left: 0, top: 0 }
    },
    routes: [
        {
            path: '/',
            component: Logged,
            children: [
                {
                    path: '/',
                    name: 'home',
                    component: () => import('@/views/Home.vue')
                },
                ...launchRoutes,
                {
                    path: '/novidades',
                    name: 'updates',
                    component: () => import('@/views/Updates.vue'),
                },
                {
                    path: '/noticias',
                    name: 'news',
                    component: () => import('@/views/News.vue'),
                },
                {
                    path: '/dicas-e-tutoriais',
                    name: 'tipsTutorials',
                    component: () => import('@/views/TipsTutorials.vue')
                },
                {
                    path: '/novidades/:slug',
                    name: 'detalhe-novidades',
                    component: () => import('@/views/Detail.vue')
                },
                {
                    path: '/noticias/:slug',
                    name: 'detalhe-noticias',
                    component: () => import('@/views/Detail.vue')
                },
                {
                    path: '/dicas-e-tutoriais/:slug',
                    name: 'detalhe-tutoriais',
                    component: () => import('@/views/Detail.vue')
                },
                {
                    path: `${import.meta.env.VITE_BASE_PATH_SEARCH}/:tagName?`,
                    name: 'buscar',
                    component: () => import('@/views/Buscar.vue')
                },
                {
                    path: `${import.meta.env.VITE_BASE_PATH_EVENT}/:slug`,
                    name: 'evento',
                    component: () => import('@/views/LaunchEvent.vue')
                },
                {
                    path: `/ee-e${import.meta.env.VITE_BASE_PATH_EVENT}/:slug`,
                    name: 'eventoPersonalizadoExterno',
                    component: () => import('@/views/LaunchEventCustom.vue')
                },
                {
                    path: `/ee${import.meta.env.VITE_BASE_PATH_EVENT}/avaliacoes`,
                    name: 'eventoPersonalizado',
                    component: () => import('@/../experiencias/review/src/views/Home.vue')
                },

                ...discourseRoutes,

                 {
                    path: '/niveis-e-progresso',
                    name: 'niveis-e-progresso',
                    component: () => import('@/views/GamificationProgress.vue')
                },

                {
                    path: import.meta.env.VITE_BASE_PATH_EXCLUSIVE_EXPERIENCES,
                    name: 'experiencia-exclusiva',
                    component: () => import('@/views/ExperienciaList.vue')
                },

                {
                    path: `${import.meta.env.VITE_BASE_PATH_EXCLUSIVE_EXPERIENCES}/detail/:slug`,
                    name: 'detail-experiencia',
                    component: () => import('@/views/DetailExperiencia.vue'),
                    props: true
                },

                {
                    path: import.meta.env.VITE_BASE_PATH_SIGNIN,
                    name: 'signin',
                    component: Signin
                },
                {
                    path: import.meta.env.VITE_BASE_PATH_SIGNUP,
                    name: 'signup',
                    component: SignUp
                },
                {
                    path: '/validate-user',
                    name: 'validate-user',
                    component: SignUp
                },
                {
                    path: '/forgot/validate',
                    name: 'pass-change',
                    component: PasswordDefinition
                },
                {
                    path: import.meta.env.VITE_BASE_PATH_MY_AREA,
                    name: 'minha-area',
                    component: MyArea
                },
                {
                    path: import.meta.env.VITE_BASE_PATH_ACTIVE_ACCOUNT,
                    name: 'active-account',
                    component: ActiveAccount
                },

                ...dynamicRoutes // Adicionar rotas dinâmicas

            ]
        },
        // {
        //     path: '/:pathMatch(.*)*',
        //     redirect: to => ({ path: '/', query: to.query })
        // }
    ]
})

import { googleAnalyticsParamEvent } from '../utils/googleAnalyticsEvents';

router.beforeEach((to, from, next) => {

    googleAnalyticsParamEvent(['lgfamilyclub', 'page_view', to.href, window.location.host + to.href])

    const publicPages = [
        '',
        '/',
        '/validate-user',
        '/forgot/validate',
        '/novidades',
        '/noticias',
        '/dicas-e-tutoriais',
        ...(__LAUNCHES_ENABLED__ ? [import.meta.env.VITE_BASE_PATH_LAUNCHES] : []),
        ...(__DISCOURSE_ENABLED__ ? ['/forum'] : []),
        '/niveis-e-progresso',
        import.meta.env.VITE_BASE_PATH_EXCLUSIVE_EXPERIENCES,
        import.meta.env.VITE_BASE_PATH_ACTIVE_ACCOUNT,
        import.meta.env.VITE_BASE_PATH_SIGNIN,
        import.meta.env.VITE_BASE_PATH_SIGNUP,
        ...publicFooterPaths,
        import.meta.env.VITE_BASE_PATH_TERMS_OF_USE_FAMILY_CLUB,
        import.meta.env.VITE_BASE_PATH_PRIVACY_POLICY,
        import.meta.env.VITE_BASE_PATH_COOKIES_POLICY,
        import.meta.env.VITE_BASE_PATH_LEGAL,
        import.meta.env.VITE_BASE_PATH_ACCESSIBILITY_HELP,
        import.meta.env.VITE_BASE_PATH_SEARCH,
        import.meta.env.VITE_BASE_PATH_TIPS_TUTORIALS,
        '/ee' + import.meta.env.VITE_BASE_PATH_EVENT + '/avaliacoes',
    ];

    const privatePages = [import.meta.env.VITE_BASE_PATH_MY_AREA];
    const publicContentRoutes = [
        'detalhe-novidades',
        'detalhe-noticias',
        'detalhe-tutoriais'
    ];
    const isPublicContent = to.name && publicContentRoutes.includes(to.name);
    const authRequired = !(
        publicPages.includes(to.path)
        || isPublicContent
        || (import.meta.env.VITE_BASE_PATH_TIPS_TUTORIALS && to.path.indexOf(import.meta.env.VITE_BASE_PATH_TIPS_TUTORIALS) >= 0)
        || (import.meta.env.VITE_BASE_PATH_SEARCH && to.path.indexOf(import.meta.env.VITE_BASE_PATH_SEARCH) >= 0)
    );
    // const pageExists = !authRequired || privatePages.includes(to.path);
    const userLogged = AuthService.getCurrentUser();
    const loggedIn = !!userLogged
    const adminPages = ['/portal/settings'];
    const adminRequired = (adminPages.includes(to.path) && userLogged?.role?.id === 1) || !adminPages.includes(to.path);
    //TODO remover apos finalizar a v2
    // const allowedPages = ['/entrar', '/']
    // trying to access a restricted page + not logged in
    // redirect to login page || !pageExists
    if (((authRequired && (!loggedIn || !adminRequired)) && (to.name !== 'buscar'))) {
        next({ name: 'signin' });
    } else {
        // if(!allowedPages.includes(to.path))
        //     next({ name: 'home' });
        next();
    }
});


export default router
